// JackRoyals — Single source of truth for excluded states (Frontend)
// Keep this file in sync with /app/backend/config/blocked_states.py
// Version: 8.0 — Updated 2026-05-15

export const EXCLUDED_STATES = [
  // Pre-existing regulated markets / constitutional prohibitions
  { code: "NV", name: "Nevada",        reason: "Regulated market — strict gaming commission jurisdiction" },
  { code: "MI", name: "Michigan",      reason: "Regulated market — Lawful Internet Gaming Act framework" },
  { code: "ID", name: "Idaho",         reason: "Constitutional gambling prohibition" },
  { code: "WA", name: "Washington",    reason: "Court-confirmed sweepstakes prohibition under existing law" },
  // Signed in 2025
  { code: "MT", name: "Montana",       reason: "SB 555 — signed May 12, 2025" },
  { code: "CT", name: "Connecticut",   reason: "SB 1235 / Public Act 25-112 — signed June 11, 2025" },
  { code: "NJ", name: "New Jersey",    reason: "A 5447 — signed Aug 15, 2025" },
  { code: "NY", name: "New York",      reason: "AB 6745 / SB-5935A — signed Dec 5, 2025" },
  { code: "CA", name: "California",    reason: "AB 831 — effective Jan 1, 2026" },
  // Signed / enacted in 2026
  { code: "IN", name: "Indiana",       reason: "HB 1052 — signed Mar 12, 2026 (effective July 1, 2026)" },
  { code: "ME", name: "Maine",         reason: "LD 2007 — signed Apr 6, 2026 (effective early July 2026)" },
  { code: "OK", name: "Oklahoma",      reason: "SB 1589 — veto overridden May 14, 2026 (effective Nov 1, 2026)" },
  // High-enforcement risk (AG action / operator exits / pending bills)
  { code: "LA", name: "Louisiana",     reason: "AG declared illegal; HB 53 pending (racketeering classification)" },
  { code: "TN", name: "Tennessee",     reason: "HB 2136 — pending governor signature; operator exits" },
  { code: "MS", name: "Mississippi",   reason: "SB 2104 died in committee 3/3/2026; AG enforcement pressure ongoing" },
  { code: "IL", name: "Illinois",      reason: "Operator exits March 2026; enforcement pressure" },
];

export const EXCLUDED_STATE_CODES = EXCLUDED_STATES.map(s => s.code);
export const EXCLUDED_STATES_COUNT = EXCLUDED_STATES.length; // 16 as of 5/15/2026

// Monitor-list (NOT blocked yet but flagged for weekly review)
export const MONITOR_STATES = [
  { code: "IA", name: "Iowa",            reason: "SF 2289 — passed all chambers; expanded enforcement powers" },
  { code: "MN", name: "Minnesota",       reason: "SF 4474 + HF 4410 — dual-currency ban advancing through Senate (May 2026)" },
  { code: "MD", name: "Maryland",        reason: "HB 1226 + HB 295 + SB 652 — passed House March 2026; pending Senate" },
  { code: "DC", name: "Washington DC",   reason: "CB 26-0656 — first hearing May 4, 2026" },
  { code: "HI", name: "Hawaii",          reason: "Operator exits March 2026" },
  { code: "ND", name: "North Dakota",    reason: "Operator exits March 2026" },
  { code: "OH", name: "Ohio",            reason: "Operator exits March 2026" },
  { code: "VT", name: "Vermont",         reason: "Operator exits March 2026" },
  { code: "FL", name: "Florida",         reason: "HB 189 pending 2026 session" },
];
